<script>
import ValidationMixin from "@/mixins/validation.mixin";
import { VInput } from "vuetify/components";
import BaseView from "@/views/BaseView.vue";

export default {
  name: "OwnerCompany",
  extends: VInput,
  mixins: [BaseView, ValidationMixin],
  props: {
    modelValue: null,
    user: Object,
    id: String,
    disabled: Boolean,
  },
  emits: ["update:modelValue"],
  data() {
    return {
      ownerCompanies: [],
      isMounted: false,
    };
  },
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    "user.isOwner"() {
      this.processValue(false);
    },
    "user.isCoordinator"() {
      this.processValue(false);
    },
    "user.name"() {
      this.processValue(false);
    },
    "user.coordinators": {
      handler() {
        this.processValue(false);
      },
      deep: true,
    },
    "user.ownerId"() {
      this.processValue();
    },
    "user.companies": {
      handler(value) {
        this.ownerCompanies = this.ownerCompanies.map((company) => {
          const userCompany = value.find((item) => item.id === company.id);

          if (userCompany) {
            return {
              ...company,
              ...userCompany,
            };
          }

          return company;
        });
      },
      deep: true,
    },
    ownerCompanies(value) {
      if (this.user.ownerId && value.length === 1) {
        this.model = value[0].id;
      }
    },
  },
  async mounted() {
    await this.processValue();
    this.isMounted = true;
    this.ensureSelection(this.ownerCompanies);
  },
  methods: {
    async processValue() {
      const ownerId = this.user.ownerId || this.user.owner?.id || (this.user.isOwner ? this.user.id : undefined);

      if (!ownerId) {
        return;
      }

      const resp = await this.$api.users.findCompanies(ownerId);
      if (resp.success) {
        this.ownerCompanies = resp.data;
      }
    },
    ensureSelection(ownerCompanies) {
      if (!this.isMounted) {
        return;
      }

      const existsInList = ownerCompanies.find((ownerCompany) => ownerCompany.id === this.user.ownerCompanyId);
      if (this.user.ownerCompanyId && !existsInList) {
        this.$emit("update:modelValue", null);
      }
    },
  },
};
</script>

<template>
  <v-select
    :id="id"
    v-model="model"
    :disabled="disabled"
    :items="ownerCompanies"
    :menu-props="{ closeOnContentClick: true }"
    :rules="[requiredValidator]"
    class="mb-0 width-100 required"
    color="primary"
    density="compact"
    hide-details="auto"
    item-title="name"
    item-value="id"
    label="Owner company"
    variant="outlined"
  >
    <template #item="{ item }">
      <v-list-item :title="item.raw.name" @click="model = item.raw.id" />
    </template>
    <template #selection="{ item }">
      <div>
        <span class="body-2">{{ item.raw.name }}</span>
      </div>
    </template>
  </v-select>
</template>

<style lang="scss">
.contact-person-container {
  width: 100%;
  flex-wrap: nowrap;
  display: flex;
  justify-content: space-between;
}
</style>
